import React from 'react';
import { InternalLinkType } from '@appTypes/internalLinkType';
import { ExternalUrl } from './ExternalUrl';
import { InternalLink } from './InternalLink';

export interface ExternalGlobalCTAType {
  _key: string;
  _type: 'ctaGlobalBlock';
  data: {
    blank: boolean;
    buttonText: string;
    internalLink: null;
    type: 'ExternalUrl';
    url: string;
  };
}

export interface InternalGlobalCTAType {
  _key: string;
  _type: 'ctaGlobalBlock';
  data: {
    blank: boolean;
    buttonText: string;
    internalLink: InternalLinkType;
    type: 'InternalLink';
    url: null;
    queryParams?: { value: string; key: string }[];
  };
}

interface Props {
  value: ExternalGlobalCTAType | InternalGlobalCTAType;
}
export const CtaGlobalBlock = ({
  value: {
    data,
    data: { type },
  },
}: Props) => {
  if (type === 'InternalLink') {
    return <InternalLink data={data as InternalGlobalCTAType['data']} />;
  }
  if (type === 'ExternalUrl') {
    return <ExternalUrl data={data as ExternalGlobalCTAType['data']} />;
  }
  return null;
};
